import { createContext, useContext, useState, useEffect } from 'react';

const CidadeContext = createContext(null);

export function CidadeProvider({ children }) {
  const [cidade, setCidadeState] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('guiacit-cidade');
    if (saved) {
      try { setCidadeState(JSON.parse(saved)); } catch {}
    }
    setLoaded(true);
  }, []);

  const setCidade = (c) => {
    setCidadeState(c);
    if (c) {
      localStorage.setItem('guiacit-cidade', JSON.stringify(c));
    } else {
      localStorage.removeItem('guiacit-cidade');
    }
  };

  return (
    <CidadeContext.Provider value={{ cidade, setCidade, loaded }}>
      {children}
    </CidadeContext.Provider>
  );
}

export const useCidade = () => useContext(CidadeContext);
